export const getStyles = (theme: any) => ({
  styles: {
    buttonsStyle: {
      display: "flex",
      height: "48px",
      marginTop: "12px",
    },

    buttonCancelStyle: {
      color: theme.palette.grey[0],
      cursor: "pointer",
      fontSize: "12px",
      marginLeft: "28px",

      "&:hover": {
        color: theme.palette.grey[0],
        opacity: 1,
      },
    },

    buttonDownloadStyle: {
      backgroundColor: theme.palette.grey[700],
      borderRadius: "100px",
      border: "none",
      color: theme.palette.grey[0],
      cursor: "pointer",
      fontSize: "12px",
      width: "142px",

      "&:hover": {
        backgroundColor: theme.palette.grey[700],
        opacity: 1,
      },
    },
  },
});
